module.exports = __webpack_public_path__ + "static/media/1.f10d97ac.jpg";